import { Breadcrumb, Flex, Heading } from '@applyboard/crystal-ui';
import { BreadcrumbItem } from '~/utils';

export function GradeConversionCreateHeading() {
  const breadcrumbItems: BreadcrumbItem[] = [
    {
      href: '/conversion-rules/grade-conversions',
      label: 'Grade Conversions',
    },
    {
      href: `/conversion-rules/grade-conversions/new`,
      label: `Create Grade Conversion`,
    },
  ] as BreadcrumbItem[];

  return (
    <Flex direction="column" gap={8}>
      <Breadcrumb items={breadcrumbItems} />
      <Flex justify="between" align="center">
        <Heading contrast="high" level={1}>
          Create Grade Conversion
        </Heading>
      </Flex>
    </Flex>
  );
}
